export default "__VITE_ASSET__qJMqMsd___"